import CustomModalLayout from "./CustomModalLayout";
import React, { SetStateAction, useState, useEffect, useRef } from "react";
import { Button } from "../../../shadcn/components/ui/button";
import GoogleSvg from "../../../icons/socialmedia/GoogleSvg";
import {
  initiateGoogleLogin,
  intiateMobileLoginWithOtp,
  intiateEmailLoginWithOtp,
} from "services";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { setGuestUser } from "store";

interface props {
  userLoggedin: boolean;
  loginModelOpen: boolean;
  registerModelOpen?: boolean;
  setLoginModalOpen: React.Dispatch<SetStateAction<boolean>>;
  setInputModalOpen: React.Dispatch<SetStateAction<boolean>>;
  setRegisterModal: React.Dispatch<SetStateAction<boolean>>;
  setAction: React.Dispatch<SetStateAction<string>>;
}

function LoginModal({
  userLoggedin,
  loginModelOpen,
  setLoginModalOpen,
  setInputModalOpen,
  setRegisterModal,
  setAction,
}: props) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    return () => {
      isSubmittingRef.current = false;
    };
  }, []);
  const form = useBetaForm({
    user_identity: "",
  });
  const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;
  const emailRegEx: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const form_constraints = {
    user_identity: {
      presence: {
        allowEmpty: false,
        message: "^Please enter a valid email or mobile number.",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  useEffect(() => {
    form.setField("user_identity", "");
    form.removeError("user_identity");
  }, [loginModelOpen]);

  const handleSubmit = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsLoading(true);
    try {
      form.value.user_identity = form.value.user_identity.trim().toLowerCase();
      if (form.validate()) {
        let isEmail = emailRegEx.test(form.value.user_identity);
        let isMobile = mobileNumberRegEx.test(form.value.user_identity);
        if (isEmail) {
          form.value.user_identity = form.value.user_identity
            .trim()
            .toLowerCase();
          await intiateEmailLoginWithOtp(form).then((res: any) => {
            if (res.message === "AttributeNotVerified") {
              dispatch(
                setGuestUser({ guestUser: { ...form.value, isEmail: true } }),
              );
              setInputModalOpen(true);
              setLoginModalOpen(false);
            } else {
              dispatch(
                setGuestUser({ guestUser: { ...form.value, isEmail: true } }),
              );
              setAction("verifyLogin");
              setInputModalOpen(true);
              setLoginModalOpen(false);
            }
          });
        } else if (isMobile) {
          await intiateMobileLoginWithOtp(form).then((res: any) => {
            if (res.message === "AttributeNotVerified") {
              dispatch(
                setGuestUser({ guestUser: { ...form.value, isEmail: false } }),
              );
              setInputModalOpen(true);
              setLoginModalOpen(false);
            } else {
              dispatch(
                setGuestUser({ guestUser: { ...form.value, isEmail: false } }),
              );
              setAction("verifyLogin");
              setInputModalOpen(true);
              setLoginModalOpen(false);
            }
          });
        } else {
          form.setErrors({
            user_identity: ["Please enter a valid email or mobile number."],
          });
        }
      }
    } catch (error: any) {
      console.log("check here error", error);
    } finally {
      isSubmittingRef.current = false;
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const data: any = await initiateGoogleLogin();
      router.push(data.redirect_to);
    } catch (error) {
      console.log("check here error", error);
    }
  };

  return (
    <CustomModalLayout
      userLoggedIn={userLoggedin}
      open={loginModelOpen}
      className={`pt-8 pb-[30px] ${!userLoggedin ? "min-h-[583px]" : ""}  `}
      childrenClassName="pl-4 pr-6"
      onClose={() => setLoginModalOpen(false)}
    >
      <div className="flex flex-col ">
        {/* Heading for Login/Register/Logout */}
        <p
          className={`font-openSans font-semibold ${
            userLoggedin ? "text-center" : ""
          } text-[24px] leading-8 text-black mb-[45px]`}
        >
          {userLoggedin ? "Log out" : "Login"}
        </p>

        {/* Input fields for name and mobile number */}
        {!userLoggedin && (
          <div>
            <p className="font-openSans font-normal text-web-body-lg leading-[22px] text-brand-bgBlack">
              Please enter your details
            </p>
            <form
              className="flex flex-col space-y-8 w-full mt-6"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="space-y-2">
                <input
                  type="text"
                  placeholder="Enter email or Mobile number"
                  value={form.getField("user_identity")}
                  onChange={(e) => {
                    const input = e.target;
                    const start = input.selectionStart;
                    const end = input.selectionEnd;

                    const lower = input.value.toLowerCase();
                    form.setField("user_identity", lower);
                    requestAnimationFrame(() => {
                      input.setSelectionRange(start, end);
                    });
                  }}
                  className="bg-[#F8F8F8] border-none focus:ring-brand-orange h-10  p-2  w-full font-openSans font-semibold text-web-body-sm leading-4 text-[#A1A0A0]"
                />
                {form.errors.get("user_identity") ? (
                  <p className="mt-2 text-sm text-red-500">
                    {form.errors.get("user_identity")[0]}
                  </p>
                ) : null}
              </div>
            </form>
          </div>
        )}

        {userLoggedin ? (
          <Button className="mt-12 w-full" onClick={() => alert("Logged out!")}>
            Confirm Logout
          </Button>
        ) : (
          <Button
            className="mt-12 w-full"
            onClick={() => handleSubmit()}
            disabled={isLoading}
          >
            {isLoading ? "Sending OTP..." : "Next"}
          </Button>
        )}

        {!userLoggedin && (
          <div className="flex items-center w-full justify-center">
            <div className=" border-2 border-[#EEEEEE] mt-8 mb-[26px] w-full" />
            <p className="mx-2 font-openSans font-semibold text-web-body-sm leading-[18px] text-brand-textLightGrey">
              OR
            </p>
            <div className=" border-2 border-[#EEEEEE] mt-8 mb-[26px] w-full" />
          </div>
        )}

        {/* Signup/Google Button */}
        {!userLoggedin && (
          <Button
            onClick={() => handleGoogleLogin()}
            className=" w-full bg-white text-black border border-gray-300 hover:bg-gray-100 flex items-center justify-center space-x-4"
          >
            <GoogleSvg />
            {/* Google icon */}
            <span className=" font-openSans font-semibold text-web-body-lg leading-[22px] text-brand-textLightGrey">
              Sign in with Google
            </span>
          </Button>
        )}
        {!userLoggedin && (
          <div className="mt-[18px] flex items-center justify-center font-openSans font-normal text-web-body-sm leading-[14px] text-brand-bgBlack">
            <p>Don`t have an account?</p>
            <button
              onClick={() => {
                setRegisterModal(true);
                setLoginModalOpen(false);
              }}
              className="text-[#0873FF] ml-2"
            >
              Sign Up
            </button>
          </div>
        )}
      </div>
    </CustomModalLayout>
  );
}

export default LoginModal;
